import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          let errorMessage = '';
          if (error.status === 500) {
            errorMessage = 'Interner Serverfehler';
          } else if (error.status === 404) {
            errorMessage = 'Nicht gefunden';
          } else if (error.status === 403) {
            errorMessage = 'Verboten';
          } else if (error.status === 400) {
            errorMessage = 'Falsche Eingabe';
          } else if (error.status === 409) {
            errorMessage = 'Konflikt: Bitte entfernen Sie die Datei aus der Liste';
          } else if (error.status === 401) {
            errorMessage = 'unberechtigt';
          } else {
            errorMessage = error.message || 'Unbekannter Fehler';
          }
          // if(errorMessage){
          //   this.toastr.error(errorMessage, '', {
          //     timeOut: 5000,
          //     closeButton: true
          //   });
          // }
        }
        return throwError(error);
      })
    );
  }
}
